module.exports = __webpack_public_path__ + "img/banner-principal.9dc7244a.png";